import type { Answer } from "types/answer";
import type { Question } from "types/question";
import { findAnswersByQuestionTag } from "./questions";
import { DIETARY } from "config/tags";

export const dietaryRestrictions = (
  answers?: Answer[],
  questions?: Question[]
): string => {
  if (!answers?.length || !questions?.length) {
    return "";
  }

  const dietaryRestrictionsAnswers = findAnswersByQuestionTag(
    DIETARY,
    answers,
    questions
  )[0]?.answers?.map(answer => answer.value);

  if (!dietaryRestrictionsAnswers?.length) {
    return "";
  }

  if (dietaryRestrictionsAnswers[0] === "No dietary restrictions") {
    return "";
  }

  return dietaryRestrictionsAnswers.length === 1
    ? ` that are ${dietaryRestrictionsAnswers[0]?.toLowerCase()},`
    : ` that are ${dietaryRestrictionsAnswers.join(", ")?.toLowerCase()},`;
};
